import { client } from "../../../api/axiosConfig";

export const addAthlete = (data) => {
    return client.post("/athletes", data);
};

export const getAthletes = (userId) => {
    return client.get(`/athletes/${userId}`);
};

export const editAthletes = (data) => {
    return client.post("/athletes/edit", data);
};

export const getPayingUsers = () => {
    return client.get("/users/paid");
};

export const checkRosterExists = (userId) => {
    return client.get(`/athletes/${userId}/exists`);
};

export const uploadRoster = (data) => {
  return client.post("/roster/upload", data);
};